import { DraftFormPopupContainer } from '../../Draft'
import {
  useRequestCreationFormConfirmation,
  useRequestDraft,
} from '../Request.hooks'

function RequestFormPopupContainer({
  title,
  onClose,
  onSubmitConfirm,
  ...containerProps
}) {
  const { getLatestDraft, setDraft } = useRequestDraft()

  const { Confirmation, handleSubmitConfirm } =
    useRequestCreationFormConfirmation({ onClose, onSubmitConfirm })

  return (
    <DraftFormPopupContainer
      {...containerProps}
      Confirmation={Confirmation}
      getLatestDraft={getLatestDraft}
      setDraft={setDraft}
      titleKey={title}
      onClose={onClose}
      onSubmitConfirm={handleSubmitConfirm}
    />
  )
}

export default RequestFormPopupContainer
